import ReactMarkdown from "react-markdown";
import { SpecialComponents } from "react-markdown/lib/ast-to-react";
import { NormalComponents } from "react-markdown/lib/complex-types";

export default function MarkdownContent({
	childrenStr,
	extra,
}: {
	childrenStr: string;
	extra?: Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents> | undefined;
}) {
	return (
		<div className="break-words min-h-full pb-8">
			<ReactMarkdown
				components={{
					h1: ({ children }) => <h1 className="text-xl font-bold mb-6">{children}</h1>,
					h2: ({ children }) => <h2 className="text-lg font-bold mb-4">{children}</h2>,
					p: ({ children }) => <p className="text-sm font-normal mb-7 leading-6">{children}</p>,
					ol: ({ children }) => <ol className="pl-4 list-none mb-4 leading-6">{children}</ol>,
					ul: ({ children }) => <ul className="pl-4 list-none mb-4 leading-6">{children}</ul>,
					a: ({ children }) => <a className="link-text leading-6">{children}</a>,
					...extra,
				}}
			>
				{childrenStr}
			</ReactMarkdown>
		</div>
	);
}
